import CheckboxInput from '@components/CheckboxInput/CheckboxInput';
import SelectInput from '@components/SelectInput/SelectInput';
import PasswordInput from '@components/TextInput/PasswordInput';
import TextInput from '@components/TextInput/TextInput';

export const signUpConfig = [
  {
    name: 'email',
    label: 'SignIn.emailUserName',
    component: TextInput,
    required: true,
    sm: 12,
    margin: 'normal'
  },
  {
    name: 'password',
    label: 'SignIn.password',
    component: PasswordInput,
    required: true,
    sm: 12,
    margin: 'normal'
  },
  {
    name: 'firstName',
    label: 'SignIn.firstName',
    component: TextInput,
    required: true,
    sm: 6,
    margin: 'normal'
  },
  {
    name: 'lastName',
    label: 'SignIn.lastName',
    component: TextInput,
    required: true,
    sm: 6,
    margin: 'normal'
  },
  {
    name: 'companyName',
    label: 'MyProfile.companyName',
    component: TextInput,
    required: true,
    sm: 12,
    margin: 'normal'
  },
  {
    name: 'function',
    label: 'SignIn.yourFunction',
    component: TextInput,
    required: true,
    sm: 12,
    margin: 'normal'
  },
  {
    name: 'street',
    label: 'SignIn.street',
    component: TextInput,
    sm: 8,
    margin: 'normal'
  },
  {
    name: 'streetNumber',
    label: 'SignIn.no',
    component: TextInput,
    sm: 4,
    margin: 'normal'
  },
  {
    name: 'city',
    label: 'SignIn.city',
    component: TextInput,
    sm: 8,
    margin: 'normal'
  },
  {
    name: 'postcode',
    label: 'SignIn.postcode',
    component: TextInput,
    sm: 4,
    margin: 'normal'
  },
  {
    name: 'country',
    label: 'SignIn.country',
    component: SelectInput,
    sm: 12,
    margin: 'normal'
  },
  {
    name: 'telNumber',
    label: 'SignIn.telNo',
    component: TextInput,
    sm: 12,
    margin: 'normal'
  },
  {
    name: 'privacy',
    label: 'SignIn.iAgree',
    linkLabel: 'SignIn.privacyStatement',
    component: CheckboxInput,
    sm: 12
  },
  {
    name: 'terms',
    label: 'SignIn.iAgree',
    linkLabel: 'SignIn.termsAndConditions',
    component: CheckboxInput,
    sm: 12
  }
];
